import z from 'zod';

export const DailyGiftStatusSchema = z.enum([
  'Awarded',
  'Pending',
  'NotAvailable',
]);

export const DailyGiftSchema = z.object({
  playerRewardId: z.number().optional(),
  rewardType: z.literal('Coins').optional(),
  rewardAmount: z.number().optional(),
  expiryDate: z.string().optional(),
  status: DailyGiftStatusSchema.optional(),
  awardedAt: z.string().optional(),
  nextAvailableAt: z.string().datetime().optional(),
  gameIds: z.array(z.number()).optional(),
});
